import React from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import { Bar } from "react-chartjs-2"
import PropTypes from "prop-types"

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

/**
 * Bar chart show overview of observations (total count, accepted, etc)
 * @param stats
 * @returns {JSX.Element}
 * @constructor
 */
const OverviewBarChart = ({ stats = {} }) => {
  const solveDataSet1 = [
    {
      label: "Observations",
      data: [
        stats?.total || 0,
        stats?.solved || 0,
        stats?.solved_success || 0,
        stats?.accepted || 0,
        stats?.declined || 0,
        stats?.udl_uploads_success || 0,
        stats?.udl_uploads_fail || 0,
      ],
      backgroundColor: "rgba(255, 199, 132, 0.5)",
    },
  ]

  const labels = [
    "total",
    "solved",
    "solved_success",
    "accepted",
    "declined",
    "UDL success",
    "UDL failed",
  ]

  const data = {
    labels,
    datasets: solveDataSet1,
  }

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: true,
        text: "Observation stats",
      },
    },
    maintainAspectRatio: false,
  }

  return <Bar options={options} data={data} />
}

OverviewBarChart.propTypes = {
  stats: PropTypes.object,
}

export default OverviewBarChart
